export enum BannerEnum {
  LANDING_PAGE = 'LANDING_PAGE',
  DELIVERY = 'DELIVERY',
  // PROMOTION_FLASH_SALE = "PROMOTION_FLASH_SALE",
  CATEGORY = "CATEGORY",
  PRODUCT_DETAIL = "PRODUCT_DETAIL",
  // PRE_ORDER = "PRE_ORDER", 
  COUPON = 'COUPON',
  PROMOTION = 'PROMOTION',
}

export enum BannerSlideEnum {
  CATEGORY = "CATEGORY",
  PRODUCT_DETAIL = "PRODUCT_DETAIL",
  PROMOTION_FLASH_SALE = "PROMOTION_FLASH_SALE",
  COUPON = "COUPON"
}
